<template>
  <div class="body">
    <baseBreadcrumb :page="$t('message.offline_wait')" :menu="$t('message.returnAndExchangeLogistics')" />
    <div class="opage">
      <!-- 待线下提货 -->

      <div class="addBtn">
        <el-button type="primary" @click="addOnlinePickup" v-if="isAuth(300)">添加线下提货</el-button>
      </div>
      <div>
        <el-table class="tableMy" :data="tableData"
          :header-cell-style="{ 'text-align': 'center', background: '#EDEFF4' }" :cell-style="{
      'text-align': 'center',
      background: '#f8f8f8',
    }">
          <el-table-column type="index" width="50" label="No">
          </el-table-column>

          <!-- 登记时间 -->
          <el-table-column property="created_at" :label="$t('message.registrationTime')"></el-table-column>
          <!-- 物流号 -->
          <el-table-column property="express_no" :label="$t('message.logisticsNumber')"></el-table-column>
          <!-- 部门 -->
          <el-table-column property="created_at" :label="$t('message.department')">
            <template slot-scope="scope">
              {{ scope.row.admin[0].role[0].organization.name }}
            </template></el-table-column>
          <!-- 提出人 -->
          <el-table-column property="created_by" :label="$t('message.peoplePutForward')"></el-table-column>
          <!-- 收件人 -->
          <el-table-column property="receive_name" :label="$t('message.recipients')"></el-table-column>

          <!-- 收件人电话 -->
          <el-table-column property="receive_mobile" :label="$t('message.recipientsPhone')"></el-table-column>
          <!-- 件数 -->
          <el-table-column property="num" :label="$t('message.jianShu')"></el-table-column>
          <!-- 运费.元 -->
          <el-table-column property="express_charge" :label="$t('message.RMBfreightCost')"></el-table-column>
          <!-- 提货联系人信息-->
          <el-table-column property="take_mobile" :label="$t('message.pickUpContactInformation')">
            <template slot-scope="scope">
              <div>
                <p>
                  {{ scope.row.take_name }}
                </p>
                <p>
                  {{ scope.row.take_mobile }}
                </p>
              </div>
            </template>
          </el-table-column>
          <!-- 地址、备注-->
          <el-table-column property="remark" :label="$t('message.AddressRemarks')"></el-table-column>

          <!-- 操作 -->
          <el-table-column property="name" :label="$t('message.operation')">
            <template slot-scope="scope">
              <div class="btnGroup">
                <!-- 收货 -->
                <el-button type="success" @click="theGoodsMe(scope.row)" size="small" v-if="isAuth(304)">{{
      $t("message.theGoods")
    }}</el-button>
                <!-- 修改 -->
                <el-button type="primary" @click="modifyThe(scope.row)" size="small" class="primary"
                  v-if="isAuth(303)">{{
      $t("message.edit")
    }}</el-button>

                <!-- 删除 -->
                <el-button type="primary" @click="deletingData(scope.row)" size="small" class="dark"
                  v-if="isAuth(302)">{{
      $t("message.delete") }}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="allpag">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="form.page"
          :page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
      <zDialog ref="dialog" :config="{
      width: '536px',
      // 线下提货登记
      title: diaTit,
      btnTxt: [this.$t('message.ok'), this.$t('message.cancel')],
    }">
        <div class="baoGuoXinXi">
          <el-form ref="ruleForm" :model="individualPickupInformation" :rules="rules" label-position="left"
            label-width="128px">
            <!-- 物流号 -->
            <el-form-item :label="$t('message.logisticsNumber') + ':'" prop="express_no">
              <el-input v-model="individualPickupInformation.express_no"></el-input>
            </el-form-item>
            <!-- 收件人 -->
            <el-form-item :label="$t('message.recipients') + ':'" prop="receive_name">
              <el-input v-model="individualPickupInformation.receive_name"></el-input>
            </el-form-item>
            <!-- 收件人电话 -->
            <el-form-item :label="$t('message.recipientsPhone') + ':'" prop="receive_mobile">
              <el-input v-model="individualPickupInformation.receive_mobile"></el-input>
            </el-form-item>
            <!-- 件数 -->
            <el-form-item :label="$t('message.jianShu') + ':'" prop="num">
              <el-input v-model="individualPickupInformation.num"></el-input>
            </el-form-item>
            <!-- 运费.元 -->
            <el-form-item :label="$t('message.RMBfreightCost') + ':'" prop="express_charge">
              <el-input v-model="individualPickupInformation.express_charge"></el-input>
            </el-form-item>
            <!-- 提货联系人 -->
            <el-form-item :label="$t('message.deliveryContact') + ':'" prop="take_name">
              <el-input v-model="individualPickupInformation.take_name"></el-input>
            </el-form-item>
            <!-- 提货联系电话 -->
            <el-form-item :label="$t('message.pickUpContactNumber') + ':'" prop="take_mobile">
              <el-input v-model="individualPickupInformation.take_mobile"></el-input>
            </el-form-item>
            <!-- 	地址和备注 -->
            <el-form-item :label="$t('message.addressAndRemarks') + ':'" prop="remark">
              <textarea v-model="individualPickupInformation.remark"></textarea>
            </el-form-item>
          </el-form>
        </div>
      </zDialog>
      <zDialog ref="shouHuoDia" :config="{
      width: '536px',
      // 收货
      title: this.$t('message.theGoods'),
      btnTxt: [this.$t('message.ok'), this.$t('message.cancel')],
    }">
        <div class="baoGuoXinXi">
          <el-form ref="receiptFormDia" :model="receiptForm" :rules="verificationOfReceipt" label-position="left"
            label-width="128px">
            <!-- 件数 -->
            <el-form-item :label="$t('message.jianShu') + ':'" prop="num">
              <el-input v-model="receiptForm.num"></el-input>
            </el-form-item>
            <!-- 运费.元 -->
            <el-form-item :label="$t('message.RMBfreightCost') + ':'" prop="express_charge">
              <el-input v-model="receiptForm.express_charge"></el-input>
            </el-form-item>
            <!-- 收货底单 -->
            <el-form-item :label="$t('message.receivingEndOfaSingle') + ':'" prop="receive_image">
              <div class="imgUp">
                <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                  :on-success="(res) => {
      handleAvatarSuccess(
        res,
        'receive_image',
        'receiptFormDia'
      );
    }
      " name="file" accept=".jpg,.jpeg,.png" :before-upload="beforeAvatarUpload">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-image :src="receiptForm.receive_image" v-if="receiptForm.receive_image"
                  style="width: 80px; height: 80px">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                  <div slot="placeholder">
                    <i class="el-icon-loading"></i>
                  </div>
                </el-image>
              </div>
            </el-form-item>
            <!-- 转账记录 -->
            <el-form-item :label="$t('message.transferRecord') + ':'" prop="transfer_image">
              <div class="imgUp">
                <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
                  :on-success="(res) => {
      handleAvatarSuccess(
        res,
        'transfer_image',
        'receiptFormDia'
      );
    }
      " name="file" accept=".jpg,.jpeg,.png" :before-upload="beforeAvatarUpload">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <el-image :src="receiptForm.transfer_image" v-if="receiptForm.transfer_image"
                  style="width: 80px; height: 80px">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                  <div slot="placeholder">
                    <i class="el-icon-loading"></i>
                  </div>
                </el-image>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </zDialog>
    </div>
  </div>
</template>
<script>
import myImage from "@/components/uploadFile/uploadFile.vue";
export default {
  data() {
    return {
      value: "",
      form: {
        status: 1,
      },
      total: 0,
      loading: null,
      tableData: [],
      diaTit: this.$t("message.offlinePickupRegistration"),
      individualPickupInformation: {}, //单个提货信息
      receiptForm: {}, //收货表单
      verificationOfReceipt: {
        // 件数
        num: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        // 运费.元
        express_charge: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        // 收货底单
        receive_image: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        // 转账记录
        transfer_image: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
      }, //收货表单验证
      // 修改商品表单验证
      rules: {
        // 物流号
        express_no: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        // 收件人
        receive_name: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        // 收件人电话
        receive_mobile: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        // 件数
        num: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        // 运费.元
        express_charge: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        // 提货联系人
        take_name: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        // 提货联系电话
        take_mobile: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        // 地址和备注
        remark: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    myImage,
  },
  computed: {},
  mounted() {
    this.getData();
  },
  methods: {
    // 获取数据
    getData() {
      if (!this.value || this.value.length == 0) {
        this.form.start_time = null;
        this.form.end_time = null;
      } else {
        this.form.start_time = this.value[0];
        this.form.end_time = this.value[1];
      }
      this.$api.signInApi.receiveOfflineListWait(this.form).then((res) => {
        // console.log("事件名", res.data.data);
        if (res.code != 0) return this.$message.error(res.msg);
        // 接下来的操作
        this.tableData = res.data.data;
        this.$forceUpdate();
      });
    },
    resetFilter() {
      this.form = {};
      this.value = [];
    },
    handleAvatarSuccess(res, name, formName) {
      this.loading.close();
      this.receiptForm[name] = res.data;
      this.validateField("receiptForm", "receive_image", formName);
    },
    // 手动触发表单验证
    validateField(dataName, type, formRef) {
      if (this[dataName][type])
        this[dataName][type] = this[dataName][type].trim();
      this.$refs[formRef].validateField(type, (v) => {
        if (v == "") {
        } else {
        }
        this.$forceUpdate();
      });
    },
    beforeAvatarUpload(file) {
      const isJPG =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      //console.log(file.type);
      if (!isJPG) {
        this.$message.error(this.$t("message.pleaseUploadPictures"));
        return isJPG;
      }
      this.loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });
    },
    // 添加线上提货
    addOnlinePickup() {
      this.individualPickupInformation = {};
      // 线下提货登记
      this.diaTit = this.$t("message.offlinePickupRegistration");
      this.$refs.dialog.open(
        "",
        () => {
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              //事件
              this.$api.signInApi
                .receiveOfflineStore(this.individualPickupInformation)
                .then((res) => {
                  if (res.code != 0) return this.$message.error(res.msg);
                  this.getData();
                  this.$refs.dialog.close();
                });
            } else {
            }
          });
        },
        () => { }
      );
    },
    // 收货
    theGoodsMe(row) {
      this.receiptForm = {};
      this.$refs.shouHuoDia.open(
        "",
        () => {
          this.$refs.receiptFormDia.validate((valid) => {
            if (valid) {
              //事件
              this.receiptForm.id = row.id;
              this.$api.signInApi
                .receiveOfflineReceive(this.receiptForm)
                .then((res) => {
                  ////console.log('事件名',res)
                  if (res.code != 0) return this.$message.error(res.msg);
                  this.getData();
                  this.$refs.shouHuoDia.close();
                  // 操作成功
                  this.$message.success(this.$t("message.operationSucceeded"));
                });
            } else {
            }
          });
        },
        () => { }
      );
    },
    // 修改
    modifyThe(row) {
      this.individualPickupInformation = JSON.parse(
        JSON.stringify({
          id: row.id,
          express_no: row.express_no,
          receive_name: row.receive_name,
          receive_mobile: row.receive_mobile,
          num: row.num,
          express_charge: row.express_charge,
          take_name: row.take_name,
          take_mobile: row.take_mobile,
          remark: row.remark,
        })
      );
      // 线下提货修改
      this.diaTit = this.$t("message.offlineDeliveryModification");
      this.$refs.dialog.open(
        "",
        () => {
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              //事件
              this.$api.signInApi
                .receiveOfflineUpdate(this.individualPickupInformation)
                .then((res) => {
                  ////console.log('事件名',res)
                  if (res.code != 0) return this.$message.error(res.msg);
                  this.getData();
                  this.$refs.dialog.close();
                });
            } else {
            }
          });
        },
        () => { }
      );
    },
    // 删除
    deletingData(row) {
      this.$ok(
        // 是否确认删除
        this.$t("message.areYouSureToDelete"),
        // 提示
        this.$t("message.prompt"),
        {
          // 确定
          confirmButtonText: this.$t("message.ok"),
          // 取消
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.$api.signInApi
            .receiveOfflineDelete({ id: row.id })
            .then((res) => {
              ////console.log('事件名',res)
              if (res.code != 0) return this.$message.error(res.msg);
              this.getData();
              // 操作成功
              this.$message.success(this.$t("message.operationSucceeded"));
            });
        })
        .catch(() => { });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.form.pageSize = val;
      this.form.page = 1;
      this.getData();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.form.page = val;
      this.getData();
    },
  },
};
</script>
<style lang='scss' scoped>
.opage {
  background-color: #f8f8f8;
  height: 100%;
  padding: 20px 20px 50px;
}

.addBtn {
  text-align: right;
  margin-bottom: 20px;
}

/deep/.tableMy {
  background-color: transparent;

  th {
    font-size: 14px;
    color: #333;
    font-weight: 400;
  }

  p {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }

  .keHu {
    p {
      text-align: center;
    }
  }

  .dingDanZhiFuRuJin {
    p {
      text-align: left;
    }
  }

  .lianXiFangShi {
    color: #2c96e7;
    cursor: pointer;
  }

  .link {
    color: #fa5058;
  }

  .btnGroup {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .el-button {
      display: flex;
      margin: 0 0 8px 0;
    }
  }
}

.baoGuoXinXi {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px 24px 1px;

  .el-select {
    width: 100%;
  }

  .imgUp {
    display: flex;
    align-items: flex-start;

    /deep/.avatar-uploader .el-upload {
      width: 80px;
      height: 80px;
      margin-right: 10px;
      border: 1px solid #e8e8e8;
      border-radius: 5px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      background-color: white;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }

    /deep/.el-image {
      width: 80px !important;
      height: 80px !important;
    }

    /deep/.imgBox {
      height: 80px;
    }
  }

  textarea {
    width: 245px;
    height: 100px;
    background: #ffffff;
    border: 1px solid #edeff4;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
    padding: 12px 16px;
  }
}

.allpag {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 25px 0;
}
</style>